<template>
  <div class="app-container">

    <el-card>
      <div slot="header" class="flex justify-between">
        <span>{{ $t('addStaff.title') }}</span>
      </div>
      <div class="">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form ref="form" :model="addStaffInfo" label-width="120px">
              <el-form-item :label="$t('addStaff.form.username')">
                <el-input v-model="addStaffInfo.username" :placeholder="$t('addStaff.form.username')"
                  maxlength="10" show-word-limit />
              </el-form-item>

              <el-form-item :label="$t('addStaff.form.position')">
                <el-select v-model="addStaffInfo.relCd" :placeholder="$t('addStaff.form.position')"
                  style="width:100%">
                  <el-option v-for="(item, index) in addStaffInfo.relCds" :key="index" :label="item.name"
                    :value="item.statusCd" />
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('addStaff.form.phone')">
                <el-input v-model="addStaffInfo.tel" :placeholder="$t('addStaff.form.phone')" maxlength="11" />
              </el-form-item>

              <el-form-item :label="$t('addStaff.form.photo')">
                <upload-image-url ref="uploadImage" :image-count="1" @notifyUploadCoverImage="handleUploadImage" />
              </el-form-item>
            </el-form>
          </el-col>

          <el-col :span="12">
            <el-form ref="form" :model="addStaffInfo" label-width="120px">
              <el-form-item :label="$t('addStaff.form.sex')">
                <el-select v-model="addStaffInfo.sex" :placeholder="$t('addStaff.form.sex')"
                  style="width:100%">
                  <el-option :label="$t('addStaff.form.male')" value="0" />
                  <el-option :label="$t('addStaff.form.female')" value="1" />
                </el-select>
              </el-form-item>

              <el-form-item :label="$t('addStaff.form.email')">
                <el-input v-model="addStaffInfo.email" :placeholder="$t('addStaff.form.email')" />
              </el-form-item>

              <el-form-item :label="$t('addStaff.form.address')">
                <el-input v-model="addStaffInfo.address" :placeholder="$t('addStaff.form.address')" />
              </el-form-item>

              <el-form-item :label="$t('addStaff.form.relatedOrg')">
                <el-input v-model="addStaffInfo.orgName" readonly @focus="handleChooseOrg"
                  :placeholder="$t('addStaff.form.relatedOrg')" />
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>

        <div class="">
          <el-button type="primary" class="float-right" @click="saveStaffInfo">
            <i class="el-icon-check"></i>&nbsp;{{ $t('common.save') }}
          </el-button>
          <el-button class="float-right" style="margin-right:20px;" @click="goBack">
            {{ $t('common.cancel') }}
          </el-button>
        </div>
      </div>
    </el-card>


    <choose-org-tree ref="chooseOrg" @switchOrg="handleSwitchOrg" />
  </div>
</template>

<script>
import { getDict } from '@/api/shop/shopApi'
import { addStaff } from '@/api/frame/staffApi'
import UploadImageUrl from '@/components/system/UploadImageUrl'
import ChooseOrgTree from '@/components/frame/chooseOrgTree/chooseOrgTree'

export default {
  name: 'AddStaff',
  components: {
    UploadImageUrl,
    ChooseOrgTree
  },
  data() {
    return {
      addStaffInfo: {
        orgId: '',
        orgName: '',
        username: '',
        sex: '',
        email: '',
        tel: '',
        address: '',
        relCd: '',
        relCds: [],
        photo: ''
      }
    }
  },
  created() {
    this.getDictData()
  },
  methods: {
    async getDictData() {
      try {
        const { data } = await getDict('u_org_staff_rel', 'rel_cd')
        this.addStaffInfo.relCds = data
      } catch (error) {
        console.error('获取字典数据失败:', error)
      }
    },
    handleUploadImage(data) {
      if (data.length > 0) {
        this.addStaffInfo.photo = data[0].fileId
      }
    },
    handleSwitchOrg(org) {
      console.log(org)
      this.addStaffInfo.orgId = org.orgId
      this.addStaffInfo.orgName = org.allOrgName
    },
    handleChooseOrg() {
      this.$refs.chooseOrg.open()
    },
    addStaffValidate() {
      return this.$refs.form.validate()
    },
    async saveStaffInfo() {
      try {
        if (!this.addStaffInfo.username || this.addStaffInfo.username.length < 2) {
          this.$message.warning('请填写员工名称（2-10个字）')
          return
        }
        if (!/^1[3-9]\d{9}$/.test(this.addStaffInfo.tel)) {
          this.$message.warning('请填写正确的11位手机号')
          return
        }
        if (!this.addStaffInfo.sex && this.addStaffInfo.sex !== '0') {
          this.$message.warning('请选择性别')
          return
        }
        if (!this.addStaffInfo.address) {
          this.$message.warning('请填写地址')
          return
        }
        if (!this.addStaffInfo.orgId) {
          this.$message.warning('请选择关联组织')
          return
        }
        if (!this.addStaffInfo.relCd) {
          this.$message.warning('请选择岗位')
          return
        }
        // 只提交必要字段，避免把字典列表一并提交
        const payload = {
          name: this.addStaffInfo.username,
          username: this.addStaffInfo.username,
          sex: this.addStaffInfo.sex,
          email: this.addStaffInfo.email,
          tel: this.addStaffInfo.tel,
          address: this.addStaffInfo.address,
          relCd: this.addStaffInfo.relCd,
          orgId: this.addStaffInfo.orgId,
          orgName: this.addStaffInfo.orgName,
          photo: this.addStaffInfo.photo
        }
        await addStaff(payload)
        this.$message.success('添加员工成功')
        this.goBack()
      } catch (error) {
        console.error('保存失败:', error)
        const msg = (error && error.message) ? error.message : '添加员工失败'
        // 避免把 axios 英文错误直接展示
        if (msg.indexOf('员工手机号') > -1 || msg.indexOf('手机号') > -1) {
          this.$message.error('员工手机号不能重复，请重新输入')
        } else if (msg.indexOf('Network') > -1 || msg.indexOf('timeout') > -1) {
          this.$message.error('网络异常，请稍后重试')
        } else {
          this.$message.error(msg)
        }
      }
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.float-right {
  float: right;
}

.ibox-content {
  padding: 20px;
}
</style>